import { useQuery } from "@tanstack/react-query";
import { baseUrl } from "../../../../../baseUrl";
import { createFileRoute } from "@tanstack/react-router";
import { fetchWithAuthHandling } from "../../../../../authHandling";
import { Box, Typography, Container, CircularProgress } from "@mui/material";
import { BuyerProfileSection } from "../../../../../components/buyers/profile/buyerProfileSection";

export const Route = createFileRoute("/_app/buyers/$buyerId/_buyerLayout/")({
  loader: ({ params }) => {
    const { buyerId } = params;
    return { buyerId };
  },
  component: BuyerProfileComponent
});

function BuyerProfileComponent() {
  const { buyerId } = Route.useLoaderData();
  const {
    data: buyerData,
    isLoading,
    error
  } = useQuery({
    queryKey: ["buyerProfile", buyerId],
    queryFn: async () => {
      const response = await fetchWithAuthHandling(
        `${baseUrl}/buyers/${buyerId}`,
        {
          method: "GET",
          credentials: "include"
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch buyer data");
      }
      return response.json();
    }
  });

  return (
    <Container
      sx={{
        mt: 5,
        maxWidth: {
          xs: "97%"
        }
      }}
    >
      {!isLoading && !buyerData && (
        <Box
          sx={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Typography variant="h6" color="textSecondary" gutterBottom>
            No User Data Found
          </Typography>
        </Box>
      )}

      {isLoading && (
        <Box
          sx={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <CircularProgress />
        </Box>
      )}
      {!isLoading && !error && buyerData && (
        <BuyerProfileSection buyerData={buyerData} buyerId={buyerId} />
      )}
    </Container>
  );
}
